const ShopMangerList = () => import('@/modules/fwscshop/shopmanager/ShopMangerList.vue')
const ShopTemplateManagerList = () => import('@/modules/fwscshop/shopTemplateManager/ShopTemplateMangerList.vue')
const GoogsTemplatelist = () => import('@/modules/fwsc/goodsTemplate/GoogsTemplatelist')
const uploadstore = () => import('@/modules/ywpro/batchother/uploadstore')

export default [
  {

    path: '/fwscshop/shoplist',
    name: 'shopManager',
    component: ShopMangerList,
    meta: {
      title: '店铺管理',
      isBlack: true
    },
  },
  {

    path: '/fwsctemplate/shopTemplatelist',
    name: 'shopTemplateManager',
    component: ShopTemplateManagerList,
    meta: {
      title: '店铺模板管理',
      isBlack: true
    },
  },
  {

    path: '/fwsctemplate/goodsTemplatelist',
    name: 'GoogsTemplatelist',
    component: GoogsTemplatelist,
    meta: {
      title: '商品模板管理',
      isBlack: true
    },
  },
  {

    path: '/yw/uploadstore',
    name: 'uploadstore',
    component: uploadstore,
    meta: {
      title: '店铺运维',
      isBlack: true
    },
  },
]
